import React from 'react';
import TradingViewChart from './trading/TradingViewChart';

const ChartTest = () => {
  const handlePriceUpdate = (price) => {
    console.log('Price updated:', price);
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#000', minHeight: '100vh' }}>
      <h1 style={{ color: 'white', marginBottom: '20px' }}>TradingView Chart Test</h1>
      <div style={{ height: '500px', width: '100%' }}>
        <TradingViewChart 
          asset="EURUSD"
          onPriceUpdate={handlePriceUpdate}
          className="w-full h-full"
        />
      </div>
    </div>
  );
};

export default ChartTest;